import userflow from 'userflow.js'

const TWELVE_HOURS = 12 * 60 * 60

export const getAuthToken = (check = false) => {
  if (window.localStorage) {
    const token = window.localStorage.getItem('protonSession')

    if (!check) {
      return token
    }

    if (token) {
      try {
        // parseJWT will fail if token is expired
        if (parseJWT(token)) {
          return token
        }
      } catch (err) {
        console.error(err)
      }
    }
  }
}

export const parseJWT = (token, timeComparison = TWELVE_HOURS) => {
  try {
    const pieces = token.split('.')
    const body = JSON.parse(atob(pieces[1]))

    const { exp } = body

    const now = new Date().getTime() / 1000

    if (!exp || exp - now >= timeComparison) {
      return body
    }
  } catch (err) {
    console.error('ERROR PARSING JWT:', err)
  }

  return null
}

export const parseJWTWithoutValidation = token => {
  try {
    const pieces = token.split('.')
    const body = JSON.parse(atob(pieces[1]))

    return body
  } catch (err) {
    console.error('ERROR PARSING JWT WITHOUT VALIDATION:', err)
  }

  return null
}

export const getUserEmail = () => {
  const token = getAuthToken()

  if (!token) {
    return null
  }

  const values = parseJWT(token)

  return values.email
}

export const isDeveloper = () => {
  const token = getAuthToken()

  if (!token) {
    return false
  }

  const values = parseJWT(token)

  return !!values?.developer
}

export const logoutUser = () => {
  userflow.reset()
  window.localStorage.removeItem('protonSession')
  window.location = '/'
}
